<template>
  <div v-if="documentUuid">
    <div class="row" v-if="isSelect">
      <div class="col-md-12 text-right">
        <button
          type="button"
          class="btn btn-danger ml-4"
          @click.prevent="deleteAllSelection"
        >
          <i class="fas fa-trash"></i>
          Supprimer
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-4">
          <form
            @submit.prevent="submit"
            @keydown="form.onKeydown($event)"
            enctype="multipart/form-data"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body mb-n2">
                    <div class="row mb-n4">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="titre"
                            >Titre <span class="text-danger">*</span></label
                          >
                          <input
                            class="form-control"
                            :class="{
                              'is-invalid': form.errors.has('titre'),
                            }"
                            id="titre"
                            v-model="form.titre"
                            type="text"
                            placeholder="Titre"
                            maxlength="100"
                          />
                          <has-error :form="form" field="titre"></has-error>
                        </div>
                      </div>
                    </div>
                    <div class="row nt-n4">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="fichier"
                            >Fichier <span class="text-danger">*</span></label
                          >
                          <div class="custom-file">
                            <input
                              id="fichier"
                              type="file"
                              class="custom-file-input"
                              :class="{
                                'is-invalid': form.errors.has('fichier'),
                              }"
                              @change="onChangeFichier"
                              accept=".jpeg, .jpg, .png, .doc, .docx, .pdf, .csv, .xls, .xlsx "
                            />
                            <label
                              class="custom-file-label"
                              for="fichier"
                              data-browser="Choisir"
                            >
                              {{ nomFichier }}
                            </label>
                          </div>
                          <has-error :form="form" field="fichier"></has-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4 mt-1">
              <div class="col-md-12 text-right">
                <button
                  v-if="form.fichier"
                  type="button"
                  class="btn btn-danger mr-4"
                  @click.prevent="onClearFichier"
                >
                  Supprimer le fichier
                </button>
                <ButtonLoader
                  :busy="form.busy"
                  type="submit"
                  customClass="btn btn-custom-primary w-40"
                  loadText="Traitement en cours..."
                  Text="Uploader"
                  style="min-width: 100px"
                ></ButtonLoader>
              </div>
            </div>
          </form>
        </div>
        <div class="col-md-12 col-lg-8">
          <DataTable
            type="edit"
            :headers="selectedHeaders"
            :documentUuid="documentUuid"
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/fichier';
import Form from 'vform';
import { objectToFormData } from 'object-to-formdata';

export default {
  data() {
    return {
      form: new Form({
        document: null,
        fichier: null,
      }),
      nomFichier: null,
      isSelect: false,
      documentUuid: null,
      selectedHeaders: [],
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'created_at',
        },
        {
          text: 'Fichier',
          align: 'start',
          sortable: true,
          value: 'titre',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  components: {
    DataTable,
  },
  methods: {
    onChangeFichier(e) {
      const file = e.target.files[0];
      this.form.fichier = file;
      this.nomFichier = file.name;
    },
    onClearFichier() {
      this.form.fichier = null;
      this.nomFichier = null;
    },
    submit() {
      this.form.document = this.documentUuid;
      this.form
        .post(URL.FICHIER, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.$refs.datatable.loadItems();
          this.init();
        })
        .catch();
    },
    init() {
      this.documentUuid = this.$route.params.documentUuid;
      this.nomFichier = null;
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.FICHIER, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.init();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
